import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import html2canvas from  "html2canvas"
import { jsPDF } from "jspdf"

const RenderComponent = ({ onRendered, children }: { onRendered: () => void; children: React.ReactNode }) => {
    useEffect(() => {
        onRendered();
    }, []);
    return <>{children}</>;
}

const addPage = async (pdf: jsPDF, wrapper: HTMLDivElement, Component: React.ReactElement, className: string): Promise<void> => {
    const div = document.createElement('div')
    div.className = className
    wrapper.appendChild(div);

    const root = ReactDOM.createRoot(div);

    await new Promise<void>((resolve) => {
        root.render(
            <RenderComponent onRendered={resolve}>
                {Component}
            </RenderComponent>
        );
    });

    const scale = Number(process.env.REACT_APP_PDF_RESOLUTION)
    const canvas = await html2canvas(div, { scale })

    // jsPDF A4 Size
    const pageMargin = 10
    const pageWidth = pdf.internal.pageSize.getWidth() - pageMargin

    const imgData = canvas.toDataURL("image/png")
    const imgWidth = canvas.width
    const imgHeight = canvas.height

    const ratio = imgHeight / imgWidth
    const imgDisplayWidth = pageWidth
    const imgDisplayHeight = imgDisplayWidth * ratio

    pdf.addImage(imgData, "PNG", pageMargin / 2, pageMargin / 2, imgDisplayWidth, imgDisplayHeight, undefined, "FAST")
}

export const exportPdf = async (Components: React.ReactElement[], className: string, fileName: string) => {
    const wrapper = document.createElement('div');
    wrapper.id = "export-pdf";

    wrapper.style.position = "absolute";
    wrapper.style.left = "-10000px";

    document.body.appendChild(wrapper);

    const pdf = new jsPDF("portrait", "mm", "a4")

    for (let i = 0; i < Components.length; i++) {
        await addPage(pdf, wrapper, Components[i], className);
        if (i < Components.length - 1) pdf.addPage()
    }

    pdf.save(`${fileName}.pdf`);
    wrapper.remove();
}